<template>
    <UiModal
        ref="modal"
        v-model:display="display"
        :title="t('Select your language')"
        tag="form"
        container-class="modal-container-language"
        @submit.prevent="submit"
        @key="onModalKey"
    >
        <UiFormGroup :label="t('Select your language') + ':'">
            <UiSelect v-model:val="lang" :options="languageOptions" @change="changeLocale"></UiSelect>
        </UiFormGroup>
        <template #footer>
            <UiButton type="submit" icon="fas fa-check">{{ t("Done") }}</UiButton>
        </template>
    </UiModal>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from "vue";
import { AVAILABLE_LANGUAGES, getLanguage, setLanguage } from "@/i18n";
import { useModalClose } from "@/composables/useModal";
import UiModal from "@/components/utils/UiModal.vue";
import UiButton from "@/components/utils/UiButton.vue";
import UiFormGroup from "@/components/utils/UiFormGroup.vue";
import UiSelect from "@/components/utils/UiSelect.vue";
import { handleModalConfirmKey } from "@/utils/form-keyboard";

defineOptions({ name: "ChangeLanguageModal" });

const display = defineModel<boolean>("display");

const modal = useTemplateRef("modal");
const close = useModalClose(modal);

const languageOptions = AVAILABLE_LANGUAGES.map((l) => {
    return { value: l.id, label: l.name };
});
const lang = ref(getLanguage());

const changeLocale = () => {
    setLanguage(lang.value);
};

const submit = (e: Event) => {
    e.preventDefault();
    setLanguage(lang.value);
    close();
};

const onModalKey = (e: KeyboardEvent) => {
    handleModalConfirmKey(e, close);
};
</script>

<style></style>
